import { render, staticRenderFns } from "./PaywallDescriptionCards.vue?vue&type=template&id=4eb88404"
import script from "./PaywallDescriptionCards.vue?vue&type=script&lang=js"
export * from "./PaywallDescriptionCards.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports